/**
 * Texts for Careers page
 */
export const careersPageText = {
    title: 'Karriere',
    titleMeta: 'Karriere — Stellenangebote | CamDiab',
    descriptionMeta: 'Entdecken Sie Karrieremöglichkeiten bei CamDiab. Werden Sie Teil unseres Teams für bessere Versorgung bei Diabetes.',
    keywords: 'CamDiab Karriere, Jobs, Stellenangebote, Diabetes',
    localeMeta: 'de_de',

    bannerTitle: 'Stellenangebote',
    bannerSubtitle: 'Möchten Sie Teil unseres Teams werden?',
    heroNote: 'Alle Stellenausschreibungen werden auf Englisch veröffentlicht.',

    introBody:
        'Wenn Sie eine neue Herausforderung suchen und sinnvolle Veränderungen mitgestalten möchten, freuen wir uns auf Ihre Nachricht. Wir investieren in unsere Mitarbeitenden – sie sind das Herz von CamDiab. Unsere Benefits sollen das Beste aus jedem herausholen, dazu gehören:',

    benefitsTitle: '',
    benefits: [
        'Großzügige betriebliche Altersvorsorge',
        'Private Krankenversicherung',
        'Lebensversicherung',
        'Jährlicher variabler Bonus',
        '29 Urlaubstage zuzüglich 8 gesetzlicher Feiertage',
        'Möglichkeit, an bahnbrechender Technologie zu arbeiten, die Diabetesmanagement und Patientenoutcomes verbessern kann',
        'Kollaboratives und dynamisches Arbeitsumfeld',
        'Wettbewerbsfähiges Gehalt und Leistungspaket, inkl. Weiterbildung und Aufstiegschancen',
    ],

    outroHtml:
        'Wenn Sie leidenschaftlich an echter Wirkung in der Praxis interessiert sind, freuen wir uns auf Sie:<a href="mailto:hr@camdiab.com" class="careers-email-link">hr@camdiab.com</a>',

    vacancies: [],

    emptyVacancyTitle: 'Derzeit keine offenen Stellen',
    emptyVacancyBody:
        'Momentan suchen wir möglicherweise niemanden, aber CamDiab wächst, und wir freuen uns immer über Menschen, die unsere Leidenschaft teilen, das Leben mit Diabetes zu verbessern. Schauen Sie später wieder vorbei.',

    applyLabel: 'Jetzt bewerben',
};
